export default __webpack_public_path__ + "static/media/BrainY Color.97f8fc17.svg";